<template>
  <main class="justify-items-center bg-greyBackground h-screen">
    <section class="px-7 w-full">
      <div>
        <credit-statement-transactions :creditStatementDataProps="creditStatementData" />
      </div>
      <!-- <div v-if="creditStatementData" class="grid md:pb-4 md:grid-cols-2 sticky bottom-0 bg-white">
        <credit-statement-card-bottom :creditStatementDataProps="creditStatementData" />
      </div> -->
      <!-- Spin Loader -->
      <spin-loader :spinLoading="isLoading"/>
      <router-view v-slot="{ Component }">
        <sidebar
          :isPanelOpen="$route.meta.showSidebar"
          @closeSidebarPanel="$router.push({ name: 'Credit Statement' })"
          position="bottom"
          paddingTopBottom="paddingTopBottomHide"
          :panelHeight="$route.meta.displayName === 'Download Statement' ? downloadStatementCustomPanelHeight : customPanelHeight"
        >
          <section
            class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-2 pt-4 sticky top-0 bg-greyBackground"
          >
            <router-link
                  :to="{
                    name: 'Credit Statement',
                    params: {
                      id: $route.params.id,
                    },
                  }"
                >
                <div title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
            </router-link>
            <h2 class="heading-text">{{ $route.meta.displayName }}</h2>
          </section>
          <div class="grid gap-4">
            <component :is="Component" />
          </div>
        </sidebar>
      </router-view>
    </section>
      <!-- footer -->
      <section>
        <span class="grid pb-20"></span>
        <div class="nav-footer px-7 w-full left-0">
          <section class="grid grid-cols-4">
            <div>
              <router-link
                class="grid justify-items-center"
                :to="{
                  name: 'Suppliers',
                }"
              >
                <img src="../assets/gPay-Supplier.svg" class="w-10 h-10 cursor-pointer" alt="Suppliers Icon">
                <p class="secondary-heading-text cursor-pointer">Suppliers</p>
              </router-link>
            </div>
            <div class="grid justify-items-center">
              <img src="../assets/gPay-Payment-Active.svg" class="w-10 h-10" alt="Payments Icon">
              <p class="font-myriad text-xs text-primary">Statement</p>
            </div>
            <div>
              <router-link
                class="grid justify-items-center"
                :to="{
                  name: 'Invite Suppliers',
                }"
              >
                <img src="../assets/gPay-Invite.svg" class="w-10 h-10 cursor-pointer" alt="Support Icon">
                <p class="secondary-heading-text cursor-pointer">Invite</p>
              </router-link>
            </div>
            <div>
              <router-link
                class="grid justify-items-center"
                :to="{
                  name: 'Support',
                }"
              >
                <img src="../assets/gPay-Support.svg" class="w-10 h-10 cursor-pointer" alt="Support Icon">
                <p class="secondary-heading-text cursor-pointer">Support</p>
              </router-link>
            </div>
          </section>
        </div>
      </section>
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import CreditStatementCard from '../components/CreditStatementCard.vue';
import CreditStatementCardBottom from '../components/CreditStatementCardBottom.vue';
import CreditStatementTransactions from '../components/CreditStatementTransactions.vue';
import Sidebar from '../components/Sidebar.vue';
import DashboardCard from '../components/DashboardCard.vue';
import SpinLoader from '../components/spinLoader.vue';

export default {
  name: 'Credit Statement',
  components: {
    CreditStatementTransactions,
    CreditStatementCardBottom,
    CreditStatementCard,
    DashboardCard,
    SpinLoader,
    Sidebar
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters(['creditAccountInfo', 'uuid']),
  },
  data() {
    return {
      isLoading: false,
      creditStatementData: undefined,
      customPanelHeight: '85%',
      downloadStatementCustomPanelHeight: 'auto',
    };
  },
  methods: {
    init() {
      this.getCustomerTransactionDetails();
    },
    getCustomerTransactionDetails() {
      this.isLoading = true;
      this.$store
        .dispatch('customerTransactionDetails', {
          uuid: this.uuid,
          urlParams: {
            start: 0,
            count: 1,
          },
        })
        .then((response) => {
          this.creditStatementData = response;
          this.isLoading = false;
          localStorage.setItem('setRedirectGPayFlow', 'Credit Statement');
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  }
};
</script>
